import { Type } from "@angular/core";
import { IQuestion } from "src/app/interface/filters";
import { InterviewsV2Service } from "src/app/services/interviews-v2.service";
import { InterviewsService } from "src/app/services/interviews.service";
import { MeUser } from "src/app/services/models/me-user";
import { OpenInterviewDetailCommand } from "src/app/shared/commands/open-interview-detail-command";
import { ActionCol } from "src/app/shared/table-col-configs/action-col";
import { DetailButtonComponent } from "src/app/shared/table-components/detail-button/detail-button.component";
import { TextCol } from "../../../../records/models/columns/text-col";

export const INTERVIEW_SUMMARY_COLUMNS_ELASTIC_SHOPPER_MASE = (
  user: MeUser,
  service: InterviewsService | InterviewsV2Service,
  question: IQuestion
) => [
  new ActionCol<any, Type<DetailButtonComponent<any>>, InterviewsService | InterviewsV2Service>(
    "surveyRequestId",
    true,
    "Survey Request Id",
    [new OpenInterviewDetailCommand()],
    DetailButtonComponent,
    true,
    undefined,
    true
  ),
  new TextCol("interviewdate"),
  new TextCol("agentName"),
  new TextCol("brand", false, undefined, undefined, true, false),
  new TextCol("customerName", true, undefined, undefined, undefined, undefined, undefined, true),
  new TextCol("anonimityRelease"),
  new TextCol("invoiceNumber", false, undefined, undefined, true),
  new TextCol("channel"),
  new TextCol("market"),
  new TextCol("dealer", false, undefined, undefined, false, false),
  new TextCol("dealerGroup"),
  new TextCol("dealerName", undefined, undefined, undefined, true, undefined, undefined, true),
  new TextCol("dealerSalespersonId", false, undefined, undefined, true),
  new TextCol("vin", true),
  new TextCol("alertRaised", false, "alertRaised", undefined, true),
  new TextCol("engine", false, undefined, undefined, true, false),
  new TextCol("modelComputed"),
  new TextCol("vehiclePurchaseCluster", false, undefined, undefined, true),
  new TextCol("orderCustomerType", undefined, "TCO/Typeutil", undefined, true),
  new TextCol("rpDtStatus", undefined, undefined, undefined, true, undefined, undefined, false),
];
